import Vue from "vue";
import Router from "vue-router";
import Login from './components/Login.vue';
import managemenus from './components/managemenus.vue';
import users from './components/users.vue';
import Menus from './components/Menus.vue';
import passcode_generate from './components/passcode_generate.vue';
import activities_notification from './components/activities_notification';
import activities_tracking from './components/activities_tracking.vue';
import encourage_management from './components/encourage_management.vue';
import home from './components/home.vue';
import squeeze_hand_management from './components/squeeze_hand_management.vue';
import register from './components/register.vue';
import walk_management from './components/walk_management.vue';
import ParticipantHistory from './components/ParticipantHistory.vue';
import firstpage from './components/firstpage.vue';
import ParticipantView from './components/ParticipantView.vue';

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      alias: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/menus",
      alias: "/menus",
      name: "menus",
      component: managemenus
    },
    {
      path: "/users",
      alias: "/users",
      name: "users",
      component: users
    },
    {
      path: "/menu",
      alias: "/menu",
      name: "menu",
      component: Menus
    },
    {
      path: "/passcode-generate",
      alias: "/passcode_generate",
      name: "passcode-generate",
      component: passcode_generate
    },
    {
      path: "/activities_notification",
      alias: "/activities_notification",
      name: "activities_notification",
      component: activities_notification
    },
    {
      path: "/activities_tracking/:id",
      alias: "/activities_tracking",
      name: "activities_tracking",
      component: activities_tracking
    },
    {
      path: "/encourage_management",
      alias: "/encourage_management",
      name: "encourage_management",
      component: encourage_management
    },
    {
      path: "/home/:id/:participant_id",
      alias: "/home",
      name: "home",
      component: home
    },
    {
      path: "/squeeze_hand_management",
      alias: "/squeeze_hand_management",
      name: "squeeze_hand_management",
      component: squeeze_hand_management
    },
    {
      path: "/register",
      alias: "/register",
      name: "register",
      component: register
    },
    {
      path: "/walk_management",
      alias: "/walk_management",
      name: "walk_management",
      component: walk_management
    },
    {
      path: '/ParticipantHistory',
      name: 'ParticipantHistory',
      component: ParticipantHistory,
      props: route => ({
        id: Number(route.params.id),
        type: Number(route.params.type)
      })
    },
    {
      path: '/ParticipantView/:id/:type',
      name: 'ParticipantView',
      component: ParticipantView,
    },
    {
      path: "/",
      alias: "/firstpage",
      name: "firstpage",
      component: firstpage
    },
    {
      path: "/firstpage",
      alias: "/firstpage",
      name: "firstpage",
      component: firstpage
    },
  ]
});


router.beforeEach((to, from, next) => {
  var page = to.path.split("/")
  // console.log(page[1],'page[1]');
  
  var firstpage = ''
  if (page[1] == 'firstpage' || page[1] == 'home') {
    firstpage = to.path
    // console.log(firstpage);
  }
  const publicPages = ['/login', '/register','/home',firstpage];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('usernilin');
  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    // next('/firstpage');
    next();
  } else {
    next();
  }

});

export default router;
